import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/visitador_medico/liquidacion';
import Liquidacion from './Liquidacion';


const ms2p = (state) => {
  return {
    ...state.vm_liquidacion,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Liquidacion);

